import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Flex, Image, Text, useColorMode } from 'theme-ui';
import actions from "../../assets/images/action.svg";
import deleteImage from "../../assets/images/delete.svg";
import EditImage from "../../assets/images/edit.svg";

import { Overlay, Popover } from 'react-bootstrap';
import { ActionDeleteById } from '../../../store/actions/CommonAction';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import theme from '../../../theme';
import { LuEye, LuPen, LuTrash } from 'react-icons/lu';
interface CellComponentProps {
    row: any;
    editTo: string;
    deleteMessage: string;
    deleteApi: string;
    toggleRefresh: () => void;
    showEdit?: boolean;
    showDelete?: boolean;
    showView?: boolean;
    viewTo?: any;
    onClick?: () => void;
}

const TableActions: React.FC<CellComponentProps> = ({ row, editTo, deleteMessage = "Are you sure you want to delete?", onClick, showEdit = true, showDelete = true, deleteApi, toggleRefresh, showView = false, viewTo }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isDeleteModelOpen, setIsDeleteModelOpen] = useState(false);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef<HTMLDivElement>(null);
    const popoverContentRef = useRef<HTMLDivElement>(null);
    const [target, setTarget] = useState(null);
    const dispatch = useDispatch();
    const confirmDelete = () => {
        dispatch(ActionDeleteById({ Query: deleteApi }, (res: any) => {
            if (res.status) {
                setIsDeleteModelOpen(false)
                toggleRefresh();
            }
        }));
    };
    const cancelDelete = () => {
        setIsDeleteModelOpen(false);
    };
    const togglePopover = (event: any) => {
        setIsPopoverOpen(!isPopoverOpen);
        setTarget(event.target);

    };
    const handleClickOutside = (event: MouseEvent) => {
        const targetNode = event.target as Node;
        if (
            popoverRef.current && !popoverRef.current.contains(targetNode) &&
            popoverContentRef.current && !popoverContentRef.current.contains(targetNode)
        ) {
            setIsPopoverOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [colorMode] = useColorMode();
    const modalHeader = colorMode === 'light' ? "#fff" : "#20283c";

    return (
        <Flex sx={{ justifyContent: 'center' }}>
            <Box sx={{ position: 'relative' }} ref={popoverRef}>
                <Overlay
                    show={isPopoverOpen}
                    target={target}
                    placement='left' >
                    <Popover ref={popoverContentRef} style={{ backgroundColor: colorMode === "light" ? "#fff" : "#374358" }} id="popover-basic" >
                        {showEdit && (
                            <Link to={editTo} style={{ textDecoration: 'none', color: `${theme.colors?.secondary}` }}>
                                <div className="text-hover" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: colorMode === "light" ? "black" : "white" }} onClick={onClick}>
                                    {colorMode === 'light' ? <Image src={EditImage} /> : <LuPen style={{ cursor: 'pointer', width: '20px', height: '20px', marginTop: '10px', color: 'white' }} />}  &nbsp;&nbsp;&nbsp;Edit
                                </div>
                            </Link>)}
                        {showDelete && (
                            <Text className="text-hover" as="p" sx={{ padding: '12px 40px', gap: '8px', cursor: "pointer", color: colorMode === "light" ? "black" : "white" }} onClick={() => {
                                setIsOpen(false)
                                setIsDeleteModelOpen(true);
                            }}>

                                <div style={{ textDecoration: 'none', color: colorMode === "light" ? "black" : "white" }} >
                                    {colorMode === 'light' ? <Image src={deleteImage} /> : <LuTrash style={{ cursor: 'pointer', width: '20px', height: '20px', color: 'white' }} />}  &nbsp;&nbsp;&nbsp;Delete
                                </div>
                            </Text>)}
                        {showView && (
                            <Link to={viewTo} style={{ textDecoration: 'none', color: `${theme.colors?.secondary}` }}>
                                <div className="text-hover " style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', color: colorMode === "light" ? "black" : "white" }}>
                                    {colorMode === 'light' ? <LuEye style={{ cursor: 'pointer', width: '20px', height: '20px', color: 'black' }} /> : <LuEye style={{ cursor: 'pointer', width: '20px', height: '20px', color: 'white' }} />}  &nbsp;&nbsp;&nbsp;View
                                </div>                            </Link>)}

                    </Popover>
                </Overlay>
                <Image src={actions} onClick={togglePopover} sx={{ cursor: "pointer" }} />
            </Box>
            <Modal isOpen={isDeleteModelOpen} toggle={cancelDelete} centered className='w-100'>
                <ModalBody className='mb-0 pb-0' style={{ backgroundColor: modalHeader }}>
                    <div style={{
                        width: '100%',
                        position: 'relative',
                        zIndex: 1,
                        backgroundColor: modalHeader,
                        border: '1px solid #black',
                        boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06);',
                        borderRadius: '4px',
                        padding: '20px 4px'
                    }}>
                        <Text className=" w-100" as="p" sx={{ color: colorMode === "light" ? "black" : "white" }} >
                            <strong>{deleteMessage}</strong>
                        </Text>
                    </div>
                </ModalBody>
                <ModalBody className='d-flex' style={{ backgroundColor: modalHeader }}>
                    <Button onClick={confirmDelete} sx={{ marginRight: '10px', width: '50%' }}>Yes</Button>
                    <Button onClick={cancelDelete} sx={{ width: '50%' }}>No</Button>
                </ModalBody>
            </Modal >
        </Flex>

    );
};

export default TableActions;
